import { DocsCliSection } from 'components/docs/docs-cli-section';
import { DocsConceptsSection } from 'components/docs/docs-concepts-section';
import { DocsGuidesSection } from 'components/docs/docs-guides-section';
import { DocsIntroSection } from 'components/docs/docs-intro-section';
import { DocsMcpSection } from 'components/docs/docs-mcp-section';
import { DocsReferenceSection } from 'components/docs/docs-reference-section';

const DocsStartSection = ({ sections = [] }) => {
	const sectionMap = Object.fromEntries(sections.map(section => [section.id, section]));

	return (
		<>
			<DocsIntroSection section={sectionMap.intro} />
			<DocsConceptsSection section={sectionMap.concepts} />
			<DocsCliSection section={sectionMap.cli} />
			<DocsMcpSection section={sectionMap.mcp} />
			<DocsReferenceSection section={sectionMap.reference} />
			<DocsGuidesSection section={sectionMap.guides} />
		</>
	);
};

export { DocsStartSection };
